import config from "lib/config";

import { sortService } from "../services/sortService";

const toLocaleShortDate = (d) =>
  d.toLocaleDateString(config.culture || undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

/**
 * Formats a sort-key timestamp in milliseconds for display (calendar day in user locale).
 * @param {number|null|undefined} milliseconds - From `getNextApplicationSortKeyMilliseconds`
 * @returns {string} Localized date or empty string if invalid
 */
export const formatNextApplicationSortKeyMilliseconds = (milliseconds) => {
  if (milliseconds == null || Number.isNaN(Number(milliseconds))) {
    return "";
  }
  const d = new Date(Number(milliseconds));
  if (Number.isNaN(d.getTime())) {
    return "";
  }
  return toLocaleShortDate(d);
};

/**
 * Sort-key milliseconds, formatted label, and whether to show the next-application date in the UI.
 * @param {Object} params
 * @param {Object} params.learningActivity - Course / learning activity
 * @param {boolean} params.isNextApplicationSort - Active sort is next application
 * @param {Date|string|number|null|undefined} params.nextApplicationSortReferenceAt - Same reference as sort
 * @returns {{ nextApplicationSortKeyMilliseconds: number|null, nextApplicationSortKeyLabel: string, showNextApplicationSortDate: boolean }}
 */
export const getNextApplicationSortDisplayState = ({
  learningActivity,
  isNextApplicationSort,
  nextApplicationSortReferenceAt,
}) => {
  const nextApplicationSortKeyMilliseconds =
    isNextApplicationSort && nextApplicationSortReferenceAt
      ? sortService.getNextApplicationSortKeyMilliseconds(
          learningActivity,
          nextApplicationSortReferenceAt,
        )
      : null;
  const nextApplicationSortKeyLabel = formatNextApplicationSortKeyMilliseconds(
    nextApplicationSortKeyMilliseconds,
  );
  const showNextApplicationSortDate = nextApplicationSortKeyLabel.length > 0;

  return {
    nextApplicationSortKeyMilliseconds,
    nextApplicationSortKeyLabel,
    showNextApplicationSortDate,
  };
};
